/* eslint-disable import/imports-first */
import './engage_cache';
import './assets/css/cl.scss';
import boot from './boot.jsx';

// TODO confirm that switching the three of these to imports didn't create problems
import React from 'react';
import moment from 'moment';
import R from 'ramda';

global.onunhandledrejection = function({ reason }) {
    setTimeout(() => {
        throw reason;
    }, 0);
};

if (process.env.NODE_ENV !== 'production') {
    window.React = React;
    global.moment = moment;
    global.R = R;
    require('./actions/offline');
}

(function(i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] =
        i[r] ||
        function() {
            (i[r].q = i[r].q || []).push(arguments);
        };
    i[r].l = 1 * new Date();
    a = s.createElement(o);
    m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
})(
    window,
    document,
    'script',
    'https://ssl.google-analytics.com/analytics.js',
    'ga'
);

/* global ga */
ga('create', 'UA-72114457-1', 'courseload.com');
ga('set', 'dimension2', window.location.hostname);

(function() {
    const l = window.location;
    if (
        window.CourseloadConfig &&
        window.CourseloadConfig.getAttribute('data-https') &&
        l.protocol === 'http:' &&
        l.port === ''
    ) {
        window.location = `https://${l.host}${l.pathname}${l.hash}`;
        return;
    }

    boot();
})();



// WEBPACK FOOTER //
// ./src/index.js